import { IAppState } from 'shared/common/state';
import { isArrayWithItems } from 'shared/utils';

export function selectIsQuickLinksAvailable(state: IAppState): boolean {
  const { quickLinks, oldQuickLinks, avgPriceInformer } = state.results;

  const hasTabs = isArrayWithItems(quickLinks) && quickLinks.some(tab => isArrayWithItems(tab.links));
  const hasOldQuickLinks = Boolean(oldQuickLinks && isArrayWithItems(oldQuickLinks.links));

  return hasTabs || hasOldQuickLinks || Boolean(avgPriceInformer);
}
